import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

type SignatureCanvasRef = SignatureCanvas & {
  getCanvas(): HTMLCanvasElement;
};

type SignaturePadProps = {
  signData?: string;
  setSignData: React.Dispatch<React.SetStateAction<string>>;
  receiverName?: string;
  setReceiverName: React.Dispatch<React.SetStateAction<string>>;
  receiverPhone?: string;
  setReceiverPhone: React.Dispatch<React.SetStateAction<string>>;
};

const SignaturePad: React.FC<SignaturePadProps> = ({
  signData,
  setSignData,
  receiverName,
  setReceiverName,
  receiverPhone,
  setReceiverPhone
}) => {
  const sigCanvas = useRef<SignatureCanvasRef | null>(null);
  const [viewSignWriter, setViewSignWriter] = useState<boolean>(false);

  const clear = () => {
    sigCanvas.current?.clear();
    setSignData('');
  };

  const save = () => {
    if (!sigCanvas.current) return;

    const canvas = sigCanvas.current.getCanvas();
    const dataUrl = canvas.toDataURL("image/png");

    setSignData(dataUrl);
    setViewSignWriter(false); 
  };

  const close = () => {
    setViewSignWriter(false);
  };

  return (
    <div className="canvas-sign">
      {/* Main Display */}
      <div className="canvas-sign-base" onClick={() => setViewSignWriter(true)}>
        {signData ? (
          <div className="canvas-sign-data">
            <img src={signData} alt="Signature" />
            <div>{receiverName}</div>
            <div>{receiverPhone}</div>
          </div>
        ) : (
          <div className="placeholder">Signature</div>
        )}
      </div>

      {/* Popup Writer */}
      {viewSignWriter && (
        <div className="canvas-sign-frame">
          <div className="canvas-sign-control">
            <button type="button" onClick={save}>Add Signature</button>
            <button type="button" onClick={clear}>Clear</button>
            <button type="button" onClick={close}>X</button>
          </div>

          <SignatureCanvas
            ref={sigCanvas}
            penColor="black"
            canvasProps={{ width: 380, height: 200, className: "canvas-sign-writer" }}
          />
          <div className="canvas-input-frame">
            <div>
              <input
                id="receiver_name"
                type="text"
                placeholder="Name"
                value={receiverName}
                onChange={(e) => setReceiverName(e.target.value)}
              />
            </div>

            <div>
              <input
                id="receiver_phone"
                type="text"
                placeholder="Phone"
                value={receiverPhone}
                onChange={(e) => setReceiverPhone(e.target.value)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignaturePad;